import {
  CUSTOMER_SATISFACTION_CHART_FAIL,
  CUSTOMER_SATISFACTION_CHART_REQUEST,
  CUSTOMER_SATISFACTION_CHART_SUCCESS,
  CUSTOMER_SATISFACTION_EXPORT_FAIL,
  CUSTOMER_SATISFACTION_EXPORT_REQUEST,
  CUSTOMER_SATISFACTION_EXPORT_SUCCESS,
  CUSTOMER_SATISFACTION_RESET,
  CUSTOMER_SATISFACTION_SUMMARY_FAIL,
  CUSTOMER_SATISFACTION_SUMMARY_REQUEST,
  CUSTOMER_SATISFACTION_SUMMARY_SUCCESS,
  CUSTOMER_SATISFACTION_TABLE_FAIL,
  CUSTOMER_SATISFACTION_TABLE_REQUEST,
  CUSTOMER_SATISFACTION_TABLE_SUCCESS,
  VISIT_PATIENT_SUMMARY_REQUEST,
  VISIT_PATIENT_SUMMARY_SUCCESS,
  VISIT_PATIENT_SUMMARY_FAIL,
  VISIT_PATIENT_GET_LIST_REQUEST,
  VISIT_PATIENT_GET_LIST_SUCCESS,
  VISIT_PATIENT_GET_LIST_FAIL,
  TRANSACTION_CUSTOMER_LIST_REQUEST,
  TRANSACTION_CUSTOMER_LIST_SUCCESS,
  TRANSACTION_CUSTOMER_LIST_FAIL,
  TRANSACTION_CUSTOMER_SUMMARY_REQUEST,
  TRANSACTION_CUSTOMER_SUMMARY_SUCCESS,
  TRANSACTION_CUSTOMER_SUMMARY_FAIL,
  TRANSACTION_CUSTOMER_EXPORT_REQUEST,
  TRANSACTION_CUSTOMER_EXPORT_SUCCESS,
  TRANSACTION_CUSTOMER_EXPORT_FAIL,
  PATIENT_VISIT_OVERVIEW_REQUEST,
  PATIENT_VISIT_OVERVIEW_SUCCESS,
  PATIENT_VISIT_OVERVIEW_FAIL,
  PATIENT_VISIT_PEAK_HOURS_REQUEST,
  PATIENT_VISIT_PEAK_HOURS_SUCCESS,
  PATIENT_VISIT_PEAK_HOURS_FAIL,
  PATIENT_VISIT_PEAK_HOURS_RESET,
  PATIENT_VISIT_OVERVIEW_EXPORT_REQUEST,
  PATIENT_VISIT_OVERVIEW_EXPORT_SUCCESS,
  PATIENT_VISIT_OVERVIEW_EXPORT_FAIL,
  PATIENT_VISIT_OVERVIEW_RESET,
  MARKETING_REVENUE_REQUEST,
  MARKETING_REVENUE_SUCCESS,
  MARKETING_REVENUE_FAIL,
  MARKETING_REVENUE_EXPORT_REQUEST,
  MARKETING_REVENUE_EXPORT_SUCCESS,
  MARKETING_REVENUE_EXPORT_FAIL,
  MARKETING_REVENUE_RESET
} from '../../constants/dashboard'

const initialState = {
  loading: false,
  loadingSla: false,
  loadingExport: false,
  visitPatientSummary: {},
  visitPatientList: [],
  slaDataChart: {},
  slaDataList: [],
  slaDataExport: null,
  loadingCustomerSatisfactionSummary: false,
  loadingCustomerSatisfactionTable: false,
  loadingCustomerSatisfactionExport: false,
  loadingCustomerSatisfactionChart: false,
  customerSatisfactionSummary: {},
  customerSatisfactionTable: [],
  customerSatisfactionChart: {},
  customerSatisfactionPageable: {
    page: 1,
    size: 10,
    hits: 0
  },
  loadingTransactionCustomerList: false,
  transactionCustomerList: [],
  transactionCustomerPageable: {
    page: 1,
    size: 10,
    total: 0,
    hits: 0
  },
  loadingTransactionCustomerSummary: false,
  transactionCustomerSummary: null,
  loadingExportTransactionCustomer: false,
  patientVisitOverview: null,
  loadingPatientVisitOverview: false,
  patientVisitPeakHours: null,
  loadingPatientVisitPeakHours: false,
  errorPatientVisitPeakHours: null,
  patientVisitPeakHoursRequestId: null,
  loadingExportPatientVisitOverview: false,
  errorPatientVisitOverview: null,
  marketingRevenue: null,
  loadingMarketingRevenue: false,
  marketingRevenueRequestId: null,
  loadingExportMarketingRevenue: false,
  errorMarketingRevenue: null,
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case VISIT_PATIENT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case VISIT_PATIENT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        visitPatientSummary: action.payload
      }
    case VISIT_PATIENT_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        visitPatientSummary: {}
      }
    case VISIT_PATIENT_GET_LIST_REQUEST:
      return { ...state, loading: true }
    case VISIT_PATIENT_GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        visitPatientList: action.payload
      }
    case VISIT_PATIENT_GET_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        visitPatientList: []
      }
    case "SLA_DATA_CHART_REQUEST":
      return { ...state, loadingSla: true, slaDataChart: [] }
    case "SLA_DATA_CHART_SUCCESS":
      return {
        ...state,
        loadingSla: false,
        slaDataChart: action.payload
      }
    case "SLA_DATA_CHART_FAIL":
      return {
        ...state,
        loadingSla: false,
        error: action.payload,
        slaDataChart: {}
      }
    case "SLA_DATA_LIST_REQUEST":
      return { ...state, loadingSla: true, slaDataList: [] }
    case "SLA_DATA_LIST_SUCCESS":
      return {
        ...state,
        loadingSla: false,
        slaDataList: action.payload,
        pageable: action.pageable
      }
    case "SLA_DATA_LIST_FAIL":
      return {
        ...state,
        loadingSla: false,
        error: action.payload,
        slaDataList: []
      }
    case "SLA_DATA_EXPORT_REQUEST":
      return { ...state, loadingExport: true }
    case "SLA_DATA_EXPORT_SUCCESS":
      return {
        ...state,
        loadingExport: false,
        slaDataExport: action.payload
      }
    case "SLA_DATA_EXPORT_FAIL":
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    case CUSTOMER_SATISFACTION_SUMMARY_REQUEST:
      return {
        ...state,
        loadingCustomerSatisfactionSummary: true,
        error: null
      }
    case CUSTOMER_SATISFACTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingCustomerSatisfactionSummary: false,
        customerSatisfactionSummary: action.payload,
        error: null
      }
    case CUSTOMER_SATISFACTION_SUMMARY_FAIL:
      return {
        ...state,
        loadingCustomerSatisfactionSummary: false,
        customerSatisfactionSummary: {},
        error: action.payload
      }
    case CUSTOMER_SATISFACTION_TABLE_REQUEST:
      return {
        ...state,
        loadingCustomerSatisfactionTable: true,
        error: null
      }
    case CUSTOMER_SATISFACTION_TABLE_SUCCESS:
      const normalizedCustomerSatisfactionTable = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.data ||
          action.payload?.content ||
          action.payload?.items ||
          action.payload?.rows ||
          []

      const normalizedCustomerSatisfactionPageable =
        action.pageable ||
        action.payload?.pageable ||
        action.payload?.pagination || {
          page: 1,
          size: Array.isArray(normalizedCustomerSatisfactionTable)
            ? normalizedCustomerSatisfactionTable.length
            : 10,
          hits: Array.isArray(normalizedCustomerSatisfactionTable)
            ? normalizedCustomerSatisfactionTable.length
            : 0
        }

      return {
        ...state,
        loadingCustomerSatisfactionTable: false,
        customerSatisfactionTable: normalizedCustomerSatisfactionTable,
        customerSatisfactionPageable: normalizedCustomerSatisfactionPageable,
        error: null
      }
    case CUSTOMER_SATISFACTION_TABLE_FAIL:
      return {
        ...state,
        loadingCustomerSatisfactionTable: false,
        customerSatisfactionTable: [],
        customerSatisfactionPageable: {
          page: 1,
          size: 10,
          hits: 0
        },
        error: action.payload
      }
    case CUSTOMER_SATISFACTION_EXPORT_REQUEST:
      return {
        ...state,
        loadingCustomerSatisfactionExport: true,
        error: null
      }
    case CUSTOMER_SATISFACTION_EXPORT_SUCCESS:
      return {
        ...state,
        loadingCustomerSatisfactionExport: false,
        error: null
      }
    case CUSTOMER_SATISFACTION_EXPORT_FAIL:
      return {
        ...state,
        loadingCustomerSatisfactionExport: false,
        error: action.payload
      }
    case CUSTOMER_SATISFACTION_CHART_REQUEST:
      return {
        ...state,
        loadingCustomerSatisfactionChart: true,
        error: null
      }
    case CUSTOMER_SATISFACTION_CHART_SUCCESS:
      return {
        ...state,
        loadingCustomerSatisfactionChart: false,
        customerSatisfactionChart: action.payload,
        error: null
      }
    case CUSTOMER_SATISFACTION_CHART_FAIL:
      return {
        ...state,
        loadingCustomerSatisfactionChart: false,
        customerSatisfactionChart: {},
        error: action.payload
      }
    case CUSTOMER_SATISFACTION_RESET:
      return {
        ...state,
        loadingCustomerSatisfactionSummary: false,
        loadingCustomerSatisfactionTable: false,
        loadingCustomerSatisfactionExport: false,
        loadingCustomerSatisfactionChart: false,
        customerSatisfactionSummary: {},
        customerSatisfactionTable: [],
        customerSatisfactionChart: {},
        customerSatisfactionPageable: {
          page: 1,
          size: 10,
          hits: 0
        },
        error: null
      }
    case TRANSACTION_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loadingTransactionCustomerList: true,
        error: null
      }
    case TRANSACTION_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loadingTransactionCustomerList: false,
        transactionCustomerList: action.payload || [],
        transactionCustomerPageable: action.pageable || {
          page: 1,
          size: 10,
          total: 0,
          hits: 0
        },
        error: null
      }
    case TRANSACTION_CUSTOMER_LIST_FAIL:
      return {
        ...state,
        loadingTransactionCustomerList: false,
        transactionCustomerList: [],
        transactionCustomerPageable: { page: 1, size: 10, total: 0, hits: 0 },
        error: action.payload
      }
    case TRANSACTION_CUSTOMER_SUMMARY_REQUEST:
      return {
        ...state,
        loadingTransactionCustomerSummary: true,
        error: null
      }
    case TRANSACTION_CUSTOMER_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingTransactionCustomerSummary: false,
        transactionCustomerSummary: action.payload,
        error: null
      }
    case TRANSACTION_CUSTOMER_SUMMARY_FAIL:
      return {
        ...state,
        loadingTransactionCustomerSummary: false,
        transactionCustomerSummary: null,
        error: action.payload
      }
    case TRANSACTION_CUSTOMER_EXPORT_REQUEST:
      return {
        ...state,
        loadingExportTransactionCustomer: true,
        error: null
      }
    case TRANSACTION_CUSTOMER_EXPORT_SUCCESS:
      return {
        ...state,
        loadingExportTransactionCustomer: false,
        error: null
      }
    case TRANSACTION_CUSTOMER_EXPORT_FAIL:
      return {
        ...state,
        loadingExportTransactionCustomer: false,
        error: action.payload
      }
    case PATIENT_VISIT_OVERVIEW_REQUEST:
      return {
        ...state,
        loadingPatientVisitOverview: true,
        errorPatientVisitOverview: null
      }
    case PATIENT_VISIT_OVERVIEW_SUCCESS:
      return {
        ...state,
        loadingPatientVisitOverview: false,
        patientVisitOverview: action.payload,
        errorPatientVisitOverview: null
      }
    case PATIENT_VISIT_OVERVIEW_FAIL:
      return {
        ...state,
        loadingPatientVisitOverview: false,
        patientVisitOverview: null,
        errorPatientVisitOverview: action.payload
      }
    case PATIENT_VISIT_PEAK_HOURS_REQUEST:
      return {
        ...state,
        patientVisitPeakHours: null,
        loadingPatientVisitPeakHours: true,
        errorPatientVisitPeakHours: null,
        patientVisitPeakHoursRequestId: action.meta?.requestId
      }
    case PATIENT_VISIT_PEAK_HOURS_SUCCESS:
      if (
        action.meta?.requestId !== state.patientVisitPeakHoursRequestId
      ) {
        return state
      }
      return {
        ...state,
        patientVisitPeakHours: action.payload,
        loadingPatientVisitPeakHours: false,
        errorPatientVisitPeakHours: null
      }
    case PATIENT_VISIT_PEAK_HOURS_FAIL:
      if (
        action.meta?.requestId !== state.patientVisitPeakHoursRequestId
      ) {
        return state
      }
      return {
        ...state,
        patientVisitPeakHours: null,
        loadingPatientVisitPeakHours: false,
        errorPatientVisitPeakHours: action.payload
      }
    case PATIENT_VISIT_PEAK_HOURS_RESET:
      return {
        ...state,
        patientVisitPeakHours: null,
        loadingPatientVisitPeakHours: false,
        errorPatientVisitPeakHours: null,
        patientVisitPeakHoursRequestId: null
      }
    case PATIENT_VISIT_OVERVIEW_EXPORT_REQUEST:
      return {
        ...state,
        loadingExportPatientVisitOverview: true,
        errorPatientVisitOverview: null
      }
    case PATIENT_VISIT_OVERVIEW_EXPORT_SUCCESS:
      return {
        ...state,
        loadingExportPatientVisitOverview: false,
        errorPatientVisitOverview: null
      }
    case PATIENT_VISIT_OVERVIEW_EXPORT_FAIL:
      return {
        ...state,
        loadingExportPatientVisitOverview: false,
        errorPatientVisitOverview: action.payload
      }
    case PATIENT_VISIT_OVERVIEW_RESET:
      return {
        ...state,
        patientVisitOverview: null,
        loadingPatientVisitOverview: false,
        patientVisitPeakHours: null,
        loadingPatientVisitPeakHours: false,
        errorPatientVisitPeakHours: null,
        patientVisitPeakHoursRequestId: null,
        loadingExportPatientVisitOverview: false,
        errorPatientVisitOverview: null
      }
    case MARKETING_REVENUE_REQUEST:
      return {
        ...state,
        loadingMarketingRevenue: true,
        errorMarketingRevenue: null,
        marketingRevenueRequestId: action.meta?.requestId
      }
    case MARKETING_REVENUE_SUCCESS:
      if (action.meta?.requestId !== state.marketingRevenueRequestId) {
        return state
      }
      return {
        ...state,
        marketingRevenue: action.payload,
        loadingMarketingRevenue: false,
        errorMarketingRevenue: null
      }
    case MARKETING_REVENUE_FAIL:
      if (action.meta?.requestId !== state.marketingRevenueRequestId) {
        return state
      }
      return {
        ...state,
        marketingRevenue: null,
        loadingMarketingRevenue: false,
        errorMarketingRevenue: action.payload
      }
    case MARKETING_REVENUE_EXPORT_REQUEST:
      return {
        ...state,
        loadingExportMarketingRevenue: true
      }
    case MARKETING_REVENUE_EXPORT_SUCCESS:
      return {
        ...state,
        loadingExportMarketingRevenue: false
      }
    case MARKETING_REVENUE_EXPORT_FAIL:
      return {
        ...state,
        loadingExportMarketingRevenue: false
      }
    case MARKETING_REVENUE_RESET:
      return {
        ...state,
        marketingRevenue: null,
        loadingMarketingRevenue: false,
        marketingRevenueRequestId: null,
        loadingExportMarketingRevenue: false,
        errorMarketingRevenue: null
      }
    default:
      return state
  }
}

export default dashboardReducer
